import Modal from "components/BaseWidgets/modal";
import React from "react";
import "./style.scss";
import { CloseIcon, PremiumIcon } from "assets/icons";
import Button from "components/BaseWidgets/button";
import ProfileImage from "assets/images/svg/interestedprofile.svg";

function GoPremiumModal({
  open,
  onCancel,
  buttonTitle,
  contentClass,
  heading,
  headingClass,
  contentTitle,
  descriptionClass,
  contentFooterClass,
  footerContent,
  modalClassName,
  wrapClassName,
  headerImage = ProfileImage,
}) {
  return (
    <Modal
      isOpen={open}
      className={`go-premium-modal ${modalClassName}`}
      wrapClassName={`go-premium-modal ${wrapClassName}`}
      onCancel={onCancel}
      title=""
      width={464}
      footer={null}
      closable={true}
      closeIcon={<CloseIcon stroke="#FFFFFF" />}
    >
      <div className={`modal-content`}>
        <div className="modal-header">
          <span className="profile-img">
            <img src={headerImage} alt="go-premium-profile" />
          </span>
        </div>
        <div
          className={`${contentClass} content flex flex-col justify-center items-center gap-8`}
        >
          <div className="content-header flex flex-col items-center">
            {heading && (
              <span className={`${headingClass} go-premium-title`}>
                {heading}
              </span>
            )}
            {contentTitle && (
              <span className={`${descriptionClass} go-premium-description`}>
                {contentTitle}
              </span>
            )}
          </div>
          {footerContent && (
            <div className={`content-footer ${contentFooterClass}`}>
              {footerContent}
            </div>
          )}
          {buttonTitle && (
            <Button
              className="submit-btn"
              href={"/plans"}
              icon={<PremiumIcon />}
            >
              {buttonTitle}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default GoPremiumModal;
